import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import { TITLE_NAV} from "../../../configs/auth";

const initialState = {
  currentRoute: '/',
  pageTitle: '',
}

const initialCommon = {
  messNotify: {
    type: '',
    message: '',
    description: '',
    stateCount: 0,
  },
  spinning: false,
}

const slice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    changePageTitle: (state, action) => {
      state.pageTitle = action.payload
      localStorage.setItem(TITLE_NAV,action.payload)
    },
  },
})

export const commonReducers = createSlice({
  name: 'common',
  initialState: initialCommon,
  reducers: {
    spinning: (state, { payload }) => {
      state.spinning = payload
    },
    notification: (state, { payload }) => {
      if (payload.type === 'success') {
        state.messNotify.message = payload.message
      } else {
        state.messNotify.message = 'error'
        state.messNotify.description = payload.message
      }
      state.messNotify.stateCount += 1
    },
  },
})

export const { changePageTitle } = slice.actions
export const { spinning, notification } = commonReducers.actions

export const titlePage = (state: RootState) => state.layout.pageTitle
export const commonState = (state: RootState) => state.commonReducers
export default slice.reducer
